import { render, staticRenderFns } from "./new-list.vue?vue&type=template&id=80449962&"
import script from "./new-list.vue?vue&type=script&lang=js&"
export * from "./new-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports